export const additionalNotesForm = 'AdditionalNotesForm'
export const flightPassengersFormName = 'flightPassengers'
export const FlightSearchFormName = 'flightSearch'
export const SeatTradeSearchResultsFormName = 'SeatTrade'
export const newBookingFormName = 'newBooking'
export const bookingIdMinLength = 1
export const bookingIdMaxLength = 12
export const removePassengerInputName = 'remove-passenger-input'
export const removeAllPassengersInputName = 'remove-all-passengers-input'
